export default __webpack_public_path__ + "static/media/logo.de6a09df.png";